module.exports = __webpack_public_path__ + "static/img/ndvi_12.54ebf16d.jpg";